"use strict";
/**
 * NOTE: These values are stored in .env files IN APP WORKSPACES, not in this package
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const env_1 = __importDefault(require("./env"));
const isTest_1 = __importDefault(require("./isTest"));
exports.default = {
    apiBaseUrl: process.env.API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '',
    appEnv: env_1.default.get('APP_ENV'),
    assetsBaseUrl: process.env.ASSETS_BASE_URL || process.env.REACT_APP_ASSETS_BASE_URL || '',
    isDebug: env_1.default.get('APP_DEBUG', 'bool', false),
    marketingSiteBaseUrl: process.env.MARKETING_SITE_BASE_URL || process.env.REACT_APP_MARKETING_SITE_BASE_URL || 'commonsenseprivacy.net',
    newRelic: {
        isEnabled: !isTest_1.default && env_1.default.get('NEW_RELIC_ENABLED', 'bool', false),
        licenseKey: env_1.default.get('NEW_RELIC_LICENSE_KEY'),
    },
    sentryDsn: env_1.default.get('SENTRY_DSN'),
    sentryEnabled: !isTest_1.default && env_1.default.get('SENTRY_ENABLED', 'bool', false),
    webAppBaseUrl: process.env.WEB_APP_BASE_URL || process.env.REACT_APP_WEB_APP_BASE_URL || '',
    stripe: {
        secretKey: process.env.STRIPE_SECRET_KEY,
        webhookSecret: process.env.STRIPE_WEBHOOK_SECRET,
    },
};
